module.exports = __webpack_public_path__ + "img/donante-unifront.b1c8df42.jpeg";